export const convertObjectOfDates = (
  dateSet: string[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  array: any,
  conversion: (date: string | Date) => Date | string,
): void => {
  dateSet.forEach((date: string) => {
    const dateExists = array?.[date]
    if (dateExists) {
      array[date] = conversion(dateExists)
    }
  })
}

export default convertObjectOfDates
